/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 26/04/2022
 */

import * as React from 'react';
import Page from '@/wpt-lib/pdf/common/Page';
import Heading from '@/wpt-lib/pdf/common/Heading';
import useData, { useTraining } from '@/wpt-lib/pdf/useData';
import { Table } from '@/wpt-lib/pdf/common/Table';
import ProgressUpdates from '@/wpt-lib/pdf/ProgressUpdates';
import Comments from '@/wpt-lib/pdf/Comments';
import TrainingUndertaken from '@/wpt-lib/pdf/training/TrainingUndertaken';
import SectionComments from '@/wpt-lib/pdf/SectionComments';
import { WorkplanCommentSection } from '@/wpt-lib/interfaces/WorkplanComment';
import MandatoryTraining from '@/wpt-lib/pdf/training/MandatoryTraining';

const Training = () => {
    const { workplan, version } = useData();
    const training = useTraining();
    const comments = useData().comments.filter((c) => c.section === WorkplanCommentSection.HEALTH_AND_SAFETY_TRAINING);

    return training.length > 0 || comments.length > 0 || workplan.year >= 2024 ? (
        <Page>
            <Heading text="Training" />
            {training.map((training, i) => (
                <Table cols={2} key={i}>
                    <TrainingUndertaken index={i} {...training.data} />
                    <ProgressUpdates item={training.workplanItem} />
                    <Comments comments={training.workplanItem.comments} />
                </Table>
            ))}
            {workplan.year >= 2024 && <MandatoryTraining mandatoryTraining={version.mandatoryTrainingDeclaration} />}
            <SectionComments heading="Training Comments" comments={comments} />
        </Page>
    ) : null;
};

export default Training;
